export default [
  {
    path: '/goga-rank',
    component: () => import('./views/Index'),
    name: 'goga-rank-season',
    redirect: { name: 'season-list' },
    children: [
      {
        path: 'season',
        name: 'season-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'management',
        },
      },
    ],
},
]
